import React, { useRef } from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { Bleed } from '../bleed'
import { QuickGlanceOverlay } from '../quick-glance-overlay'
import useEscHandler from '../use-esc-handler'
import useClickAway from '../use-click-away'

export default function AutosuggestOverlay({
  children,
  overlay,
  inline,
  inputRef,
  onCloseFinished,
  role = 'menu',
  overlayRef: contentRef,
  ...props
}) {
  const overlayRef = useRef(null)
  // Helps autosuggest stay in sync with the overlay's isOpen state
  useEscHandler({
    handler: onCloseFinished,
    enabled: overlay.isOpen,
  })

  useClickAway({
    enabled: overlay.isOpen,
    handler: (_, target) => {
      if (target !== inputRef.current) onCloseFinished()
    },
    contentRef: overlayRef,
  })

  return (
    <div {...sanitizeProps(props)}>
      <QuickGlanceOverlay
        ref={contentRef}
        overlayRef={overlayRef}
        maxWidth="600px"
        role={role}
        {...overlay}
        focusRef={inputRef}
        placement={['bottom', 'top']}
      >
        <Bleed all>{children}</Bleed>
      </QuickGlanceOverlay>
    </div>
  )
}
